import Services from './slider-services';
import Projects from './slider-projects';

const sliders = {Services, Projects};

export default sliders;